import React from "react";
import { Icon } from "components/shared/icon/Icon";

interface SelectProps {
  iconId: string;
  iconClassName?: string;
  id: string;
  options: SelectOption[];
  selected: any;
  horizontal?: boolean;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  disabled?: boolean;
}

interface SelectOption {
  name: string;
  value: any;
}

export const Select: React.FC<SelectProps> = ({
  iconId,
  iconClassName,
  id,
  options,
  selected,
  onChange,
  disabled
}: SelectProps) => {
  return (
    <>
      <div className="input-group mb-3">
        <div className="input-group-prepend">
          <span className="input-group-text" id={"icon"}>
            <Icon id={iconId} className={iconClassName} />
          </span>
        </div>
        <select
          className="form-control"
          id={id}
          value={selected}
          onChange={onChange}
          disabled={disabled}
        >
          {options.map(({ name, value }, idx) => {
            return (
              <option key={idx} value={value}>
                {name}
              </option>
            );
          })}
        </select>
      </div>
    </>
  );
};
